import { StreamActions } from "@hotwired/turbo"

// The studio's phone (layouts/_studio_phone): after a save, the page in it
// takes the new render in place — morphed by Turbo inside the frame
// (window.studioRefresh, defined by creators/pages/show in preview=studio),
// so nothing blinks and the scroll stays. A frame without it (still loading,
// an older page) gets its address changed instead.
//
// The refresh in place covers the page's top (its header and links), or
// its places section (part: "places": Design's Map and Listing, a place
// added, hidden or removed); full: true reloads the frame.
export function refreshPhone(version, { full = false, part = "top" } = {}) {
  const frame = document.getElementById("studio_frame")
  if (!frame) return
  const inner = frame.contentWindow
  if (!full && inner && typeof inner.studioRefresh === "function") {
    inner.studioRefresh(version, part)
    return
  }
  const url = new URL(frame.src, window.location.href)
  url.searchParams.set("v", version)
  frame.src = url.toString()
}

// <turbo-stream action="refresh_phone" version="…">: the same, from a
// controller answering a Turbo form (the profile's autosave).
StreamActions.refresh_phone = function () { refreshPhone(this.getAttribute("version")) }

// The studio's panel is a Turbo frame (layouts/spots_studio): a form sent in
// it changes what the page shows, so the phone follows.
document.addEventListener("turbo:submit-end", (event) => {
  if (!event.detail.success || !event.target.closest("#studio_panel")) return
  // A search (GET) changes nothing on the page.
  if (event.detail.formSubmission?.isSafe) return
  const action = event.detail.formSubmission?.location?.pathname || ""
  // A place added or removed changes the places section: swapped in place.
  refreshPhone(Date.now(), { part: action.startsWith("/places") ? "places" : "top" })
})
